import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';

export const TAG_SYSTEM = 'hci.system';
export const TAG_FAILED = 'failed';
export const TAG_MANAGEMENT = 'management';
export const TAG_PRIMARY = 'primary';

export type TagKey = typeof TAG_SYSTEM | typeof TAG_FAILED | typeof TAG_MANAGEMENT | typeof TAG_PRIMARY;

export type TagInfo = {
  name: string;
  type: string;
  title: string;
  inverse: boolean;
}

export const TAGS = computedLocale<Record<TagKey, TagInfo>>(() => ({
  [TAG_SYSTEM]: {
    name: TAG_SYSTEM,
    type: 'info',
    title: i18n.t('Tag~System'),
    inverse: false,
  },
  [TAG_FAILED]: {
    name: TAG_FAILED,
    type: 'danger',
    title: i18n.t('Tag~Failed'),
    inverse: true,
  },
  [TAG_MANAGEMENT]: {
    name: TAG_MANAGEMENT,
    type: 'info',
    title: i18n.t('Tag~Management'),
    inverse: false,
  },
  [TAG_PRIMARY]: {
    name: TAG_PRIMARY,
    type: 'info',
    title: i18n.t('Tag~Primary'),
    inverse: false,
  },
}));
